import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

interface Region {
  regionId: string;
  regionCode: string;
  regionName?: string;
}
@Injectable({
  providedIn: 'root'
})
export class ConfigurationService {

  regionsList: Region[] = environment.regions || [];
  constructor() { }

  get(key: string) {
    return environment[key];
  }

  setRegionList(regions: Region[]) {
    this.regionsList = regions;
  }

  getRegions() {
    return this.regionsList;
  }
}